import { Button, Modal, Box, Typography } from "@mui/material";

const style = {
  borderRadius: "10px",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  padding: "20px !important",
  bgcolor: "background.paper",
  boxShadow: 24,
  maxHeight: "40%",
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: "10px",

};

function ErrorModal(props) {
  return (
    <Modal open={props.open} onClose={props.onClose}>
      <>
        <Box sx={style}>
          <Typography id="shadow" style={{fontSize:"20px", fontWeight:"150px"}}>
            {" "}
            Something went wrong. Please try again later.
          </Typography>
          <Button
            style={{
              width:"100px", 
              height:"35px",
              backgroundColor: "#002d82",
              textTransform: "unset !important",
              paddingRight: "10px",
              marginLeft: "20px",
              marginTop:"5px",
              marginBottom:"5px"}}
            //id="modal-close-btn"
            variant="contained"
            onClick={props.onClose}
          >
            Ok
          </Button>
        </Box>
      </>
    </Modal>
  );
}

export default ErrorModal;
